// src/hooks/useContacto.js
import { useState } from "react"
import { supabase } from "../../lib/supabaseClient"

export function useContacto() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const enviarContacto = async (email, mensaje) => {
    setLoading(true)
    setError(null)
    setSuccess(false)

    try {
      const { data, error: supabaseError } = await supabase
        .from("contacto")
        .insert([{ email, mensaje }])

      if (supabaseError) throw supabaseError

      setSuccess(true)
      return data
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return { enviarContacto, loading, error, success }
}
